import {
    type RejectCompanyUpdateRequestResponseType,
    type RejectCompanyUpdateRequestRequestType
} from "./type";
import {
    request
} from "../request";

const rejectCompanyUpdateRequest = async (
    params: RejectCompanyUpdateRequestRequestType
): Promise<RejectCompanyUpdateRequestResponseType> => {
    return await request<RejectCompanyUpdateRequestResponseType>(
        "/request/rejectCompanyUpdateRequest",
        {
            body: JSON.stringify(params),
            method: "POST"
        }
    );
};
export default rejectCompanyUpdateRequest;
